/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/** Checkbox im Checkout muss angekreuzt sein*/

$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
    if ($('#agree').is(':checked')) {
      $(this).submit();
    }
    else {
      alert("Please agree to continue.");
      return false;
    }
  });
});


/**
 Display/Hide Input field when Variant is changed & SKU contains is PE-IN
*/
document.addEventListener('variant:changed', PersUpdate);

function PersUpdate() {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var Personalisierung = document.getElementById('Personalisierung');
  var PersonalisierungDIV = document.getElementById('Personalisierung-DIV');

  
  if (variant.sku.includes('PE-IN')) {
    PersonalisierungDIV.style.display = "block";
    Personalisierung.setAttribute('required','');
    Personalisierung.setAttribute('name','properties[Initialen]');
    
  } else {
    PersonalisierungDIV.style.display = "none";
    Personalisierung.removeAttribute('required','');
    Personalisierung.removeAttribute('name','properties[Initialen]');
    Personalisierung.value='';
  }
}

/** Insider-Collection Page Passwortschutz   */
//Funktion zum Hashen vom Eingabetext
String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
  

  function passWord() {
  const input=document.getElementById('Insider-Passwort')
  let pass1=input.value.toLowerCase().hashCode().toString()
  //hashCode() sorgt für verHashung
  //toString() sorgt für erstellung String (benötigt für toLowerCase() Funktion wenn Text im Passwort enthalten ist (durch verhashung eigentlich nicht mehr notwendig, da alles Zahlen))
  //zeigt das eingegebene Passwort in der Console an
  //  console.log(pass1)
  if (pass1.toLowerCase() == "1480886809") { //Eingabetext und Passwort müssen den gleichen Hash besitzen.. in diesem Fall die Zahl: -1675904525 (Derzeitiges Passwort: "ilovecalisso")
  //toLowerCase wird eigetlich nicht mehr benötigt, da verHasung nur Ziffern ausspuckt
  window.open('/collections/insider-collection.html');

    }
  else {
  	alert('Access denied - password incorrect, try again.');

    }
  }

/** Toggle für Switch Buttons auf Produktseite */
  function ToggleBtnSwitch() {
  
  const btnmainwrapper = document.getElementById("btn-main-wrapper")
  const togglebtn = document.getElementById("switch-btn-toggle")
  const XSymbol = document.getElementById("X-Symbol")
  const RightSymbol = document.getElementById("Right-Symbol")

//mit den Klassen wird das geöffnete div eine automatische Höhe einnehmen, aber hat dafür eine Transition

  if (btnmainwrapper.className == "btn-main-wrapper--closed" ) {
    btnmainwrapper.classList.replace("btn-main-wrapper--closed","btn-main-wrapper--open");
    XSymbol.style.display = "unset"
    RightSymbol.style.display = "none"

  }
    else {
    btnmainwrapper.classList.replace("btn-main-wrapper--open","btn-main-wrapper--closed");
    XSymbol.style.display = "none"
    RightSymbol.style.display = "unset"
    }
}

//Timer

/*
var countDownDate = new Date("2022-5-22 23:59:59").getTime();

// Update the count down every 1 second
var EverySecond = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  document.getElementById("Timer").innerHTML = "Drop endet in: <br>" + days + "d " + hours + "h "
  + minutes + "m " + seconds + "s ";

  // If the count down is finished, write some text
  if (distance < 0) {
    clearInterval(EverySecond);
    document.getElementById("Timer").innerHTML = "Abgelaufen";
  }
}, 1000);
**/
